import { Box, keyframes } from '@mui/material';
import { DARK_GREY, DARKER_GREY } from 'utils/theme';

const dotFlashing = keyframes` 
  0% {
    background-color: lightgray;
  }

  50%,100% {
    background-color:  ${DARKER_GREY};
  }
`;

export const DotComponent = ({ animationTime }: { animationTime: number }) => (
  <Box
    role="presentation"
    sx={{
      background: DARK_GREY,
      borderRadius: '50%',
      animation: `${dotFlashing} 1s infinite alternate`,
      animationDelay: `${animationTime}s`,
    }}
    height="5px"
    width="5px"
  />
);
